export const initGA = () => {
  window.dataLayer = window.dataLayer || [];
};

export const trackPageview = (url) => {
  console.log('[Analytics] trackPageview called', { url });
  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
  console.log('[Analytics] pageview event pushed to dataLayer:', url);
};

export const trackEvent = ({ name, params }) => {
  console.log('[Analytics] trackEvent called', { name, params });
  window.dataLayer.push({
    event: name,
    ...params,
  });
  console.log('[Analytics] event pushed to dataLayer:', name, params);
};